/**
 *
 * @param str any string
 * @returns a boolean indicating if the string includes a valid object
 */

export default function isJsonString(str: string | null | undefined) {
	if (!str) return false;
	try {
		JSON.parse(str);
	} catch (e) {
		process.env.NODE_ENV !== "development" && console.error("invalid JSON String");
		return false;
	}
	return true;
}
